import { render, staticRenderFns } from "./Licenseblock.vue?vue&type=template&id=7b578f23"
import script from "./Licenseblock.vue?vue&type=script&lang=js"
export * from "./Licenseblock.vue?vue&type=script&lang=js"
import style0 from "./Licenseblock.vue?vue&type=style&index=0&id=7b578f23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports